module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Media/Youtube-f94294710c7fbb1537b5ff5639ad854b.svg";